@import (reference) '../../../../../constants/spacing.module.less';

// Layout dimensions
@zone-comparison-max-width: 1400px;
@header-text-max-width: 686px;
@selector-and-table-width: 440px;

.zone-comparison-section {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: @space-24;
  max-width: @zone-comparison-max-width;
}

.header-text {
  align-items: center;
  max-width: @header-text-max-width;
  text-align: center;
}

.map-and-table-container {
  display: flex;
  flex-flow: row wrap;
  gap: @space-24 @space-64;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.selector-and-table-container {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  width: @selector-and-table-width;
}

.more-info {
  text-align: center;
}

.loading-indicator {
  height: 500px;
}
